(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('CATEGORIA_RSS_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<categoria-rss-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                '></categoria-rss-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (CategoriaRss) {
                        return new CategoriaRss();
                    }
                }
            }
        });
})();
